module.exports = __webpack_public_path__ + "img/require-icon-1.80ad8b6a.png";